export default __webpack_public_path__ + "media/images/mailer-new/common/logo-footer-dc8cf99dc114f4ca183e1a40025f5c0f.png";